export default __webpack_public_path__ + "images/OO.c062a2e.png";